module.exports = __webpack_public_path__ + "static/img/mercado_pago.c920162a.png";